var map = {
	"./ar/activities.json": 8258,
	"./ar/auth.json": 1901,
	"./ar/common.json": 8634,
	"./ar/community.json": 880,
	"./ar/consultations.json": 5991,
	"./ar/home.json": 164,
	"./ar/learn.json": 8203,
	"./ar/profile.json": 3096,
	"./en/activities.json": 6690,
	"./en/auth.json": 5021,
	"./en/common.json": 9802,
	"./en/community.json": 7056,
	"./en/consultations.json": 5495,
	"./en/home.json": 4820,
	"./en/learn.json": 155,
	"./en/profile.json": 1432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;